import { render, staticRenderFns } from "./MemberAdd.vue?vue&type=template&id=256dc440&scoped=true"
import script from "./MemberAdd.vue?vue&type=script&lang=js"
export * from "./MemberAdd.vue?vue&type=script&lang=js"
import style0 from "./MemberAdd.vue?vue&type=style&index=0&id=256dc440&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256dc440",
  null
  
)

export default component.exports